import { Component, Input } from '@angular/core';

import { OnInit } from '@angular/core';

import { EventBusService } from '../../services/event-bus.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
  selector: 'rm-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationsComponent implements OnInit {

  @Input()
  productId: string;

  @Input()
  gcp: string;

  @Input()
  gln: string;

  locations: any[];

  subscriptions: any[] = [];

  constructor(
    private ebService: EventBusService,
    private globalCfgService: GlobalCfgService
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.ebService.locationsValue$.subscribe(
      (locations) => {
        this.locations = locations;
        this.showMap();
      }
    ));

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.loadLocations(this.productId, this.gcp, this.gln);
      }
    ));

    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }
    this.loadLocations(this.productId, this.gcp, this.gln);
  }

  loadLocations(gtin, gcp, gln) {
    var obj = {};

    if (gcp) {
      obj['gcp'] = gcp;
    }

    if (gtin) {
      obj['gtin'] = gtin;
    }

    if (gln) {
      obj['gln'] = gln;
    }

    this.ebService.loadLocations(obj);
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  showMap() {
    var locationHeader = [['Latitude', 'Longitude', 'Address', '# of Products', '# of Invalid']];
    var locObj = locationHeader.concat(this.locations);

    window['google'].charts.load('current', {
      'packages': ['geochart'],
      // Note: you will need to get a mapsApiKey for your project.
      // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
      'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
    });

    window['google'].charts.setOnLoadCallback(drawMarkersMap);

    var me = this;
    var user = this.globalCfgService.getFullUserObj();

    function drawMarkersMap() {

      var data = window['google'].visualization.arrayToDataTable(locObj);


      var options = {
        displayMode: 'markers',
        colorAxis: { colors: ['#1a55ae', 'blue'] }
      };

      if (!user.hasGlobalPresence) {
        options['domain'] = user.presenceInCountry;
        options['region'] = user.presenceInCountry;
      }

      var chart = new window['google'].visualization.GeoChart(document.getElementById('locations_div'));
      chart.draw(data, options);
    };
  }
}